import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import IconRail from './icon-rail'
import MobileMenu from './mobile-menu'
import TopBar from './top-bar'
import CommandPalette from './command-palette'
import ContentErrorBoundary from './content-error-boundary'
import { getActiveEntry, navEntries } from './nav-config'

const STORAGE_KEY = 'li.superadmin.railExpanded'
const readExpanded = () => {
  try { return window.localStorage.getItem(STORAGE_KEY) === 'true' } catch (error) { return false }
}

function DashboardShell({ children }) {
  const { pathname } = useLocation()
  const [expanded, setExpanded] = useState(readExpanded)
  const [mobileOpen, setMobileOpen] = useState(false)
  const [paletteOpen, setPaletteOpen] = useState(false)
  const activeEntry = getActiveEntry(pathname)

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, String(expanded)) } catch (error) {}
  }, [expanded])
  useEffect(() => setMobileOpen(false), [pathname])
  useEffect(() => {
    const onKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        setPaletteOpen(true)
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return (
    <div className='tw-min-h-screen tw-min-w-0 tw-bg-canvas tw-font-sans tw-text-ink'>
      <IconRail entries={navEntries} activeKey={activeEntry?.key} expanded={expanded} />
      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} entries={navEntries} activeKey={activeEntry?.key} />
      <div className={`tw-flex tw-min-h-screen tw-min-w-0 tw-flex-col tw-transition-[padding] tw-duration-200 ${expanded ? 'md:tw-pl-[220px]' : 'md:tw-pl-[72px]'}`}>
        <TopBar expanded={expanded} onToggleRail={() => setExpanded((value) => !value)} mobileOpen={mobileOpen} onOpenMobile={() => setMobileOpen(true)} onOpenPalette={() => setPaletteOpen(true)} />
        <main className='tw-min-w-0 tw-flex-1 tw-overflow-x-clip tw-p-4 sm:tw-p-6 lg:tw-p-8'>
          <div className='tw-mx-auto tw-w-full tw-max-w-[1440px]'>
            <ContentErrorBoundary resetKey={pathname}>{children}</ContentErrorBoundary>
          </div>
        </main>
      </div>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} entries={navEntries} />
    </div>
  )
}

export default DashboardShell
